// Auto-generated by Storyline Creator (Vite)

export default {
  "id": "repaired_hero",
  "title": "The Repaired Hero",
  "coverImage": "",
  "requirements": [
    {
      "type": "flag",
      "key": "give_potion",
      "eq": true
    }
  ],
  "startScene": "start",
  "scenes": {
    "start": {
      "steps": [
        {
          "type": "page",
          "image": "/images/repaired_hero_1.png",
          "text": "Click to continue."
        },
        {
          "type": "page",
          "image": "/images/repaired_hero_2.png",
          "text": "Click to continue."
        },
        {
          "type": "choice",
          "image": "/images/repaired_hero_3.png",
          "left": {
            "label": "Accept.",
            "if": [],
            "effects": [
              {
                "type": "sanity",
                "delta": 10
              },
              {
                "type": "flag",
                "key": "accept_trinket",
                "value": true
              },
              {
                "type": "gainTrinketRandom",
                "count": 1,
                "pool": "any"
              }
            ],
            "nextScene": "end",
            "nextStorylet": "the_notice"
          },
          "right": {
            "label": "Decline.",
            "if": [],
            "effects": [
              {
                "type": "sanity",
                "delta": -5
              },
              {
                "type": "flag",
                "key": "accept_trinket",
                "value": false
              }
            ],
            "nextScene": "scene_1",
            "nextStorylet": "the_warning"
          },
          "prompt": "Drag to choose."
        }
      ]
    },
    "scene_1": {
      "steps": [
        {
          "type": "page",
          "image": "/images/repaired_hero_5.png",
          "text": "Click to continue."
        },
        {
          "type": "page",
          "image": "/images/repaired_hero_6.png",
          "text": "Click to continue."
        },
        {
          "type": "ending",
          "image": "/images/repaired_hero_7.png",
          "effects": [],
          "text": "Click to end."
        }
      ]
    },
    "end": {
      "steps": [
        {
          "type": "ending",
          "image": "/images/repaired_hero_4.png",
          "effects": [
            {
              "type": "gainTrinketRandom",
              "count": 1,
              "pool": "common"
            }
          ],
          "text": "Click to end."
        }
      ]
    }
  }
};
